// ** list Terminal
export const LIST_TERMINAL_INITIATED = "LIST_TERMINAL_INITIATED";
export const LIST_TERMINAL_SUCCESS = "LIST_TERMINAL_SUCCESS";
export const LIST_TERMINAL_FAILED = "LIST_TERMINAL_FAILED";

// ** reset error
export const RESET_ERRORS = "RESET_ERRORS";
